var React = require('react');

function AttentionIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},React.createElement("path",{"d":"M.54 0h3.92c.298 0 .54.228.54.508L3.919 14.492c0 .28-.242.508-.54.508H1.621c-.3 0-.54-.228-.54-.508L0 .508C0 .228.242 0 .54 0zM2.5 22a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"})));
}

AttentionIcon.defaultProps = {"width":"5","height":"22","viewBox":"0 0 5 22"};

module.exports = AttentionIcon;

AttentionIcon.default = AttentionIcon;
